module.exports = __webpack_public_path__ + "static/media/CalendarAlt.9d7a4e72.svg";